// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-chart-widget-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  container-type: inline-size;
}

.index-chart-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 404px;
}

.index-chart-header-mobile {
  width: 100%;
}

.index-chart-period-tab-bar {
  display: flex;
  align-items: center;
  flex: 1;
  background-color: var(--row-dark);
  padding: 2px 4px;
  border-radius: 600px;
  gap: 0;
}

.index-chart-period-tab {
  flex: 1;
  height: 32px;
  padding: 4px 6px;
  border: none;
  background: none;
  border-radius: 600px;
  color: var(--text-secondary);
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  transition:
    background 0.15s,
    color 0.15s;
}

.index-chart-period-tab:hover:not(.index-chart-period-tab-active) {
  background-color: var(--color-brand-hover2);
}

.index-chart-period-tab-active {
  background-color: var(--color-brand);
  color: var(--text-invert);
}

.index-chart-chart-type-button-wrapper {
  position: relative;
  flex-shrink: 0;
}

.index-chart-chart-type-button {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-brand);
  border-radius: 4px;
  background: none;
  cursor: pointer;
  transition: background 0.15s;
}

.index-chart-chart-type-button:hover {
  background-color: var(--color-brand-hover2);
}

.index-chart-chart-type-button svg path {
  fill: var(--color-brand);
}

.index-chart-chart-type-button-open {
  background-color: var(--color-brand-hover2);
}

/* .index-chart-chart-type-button-open svg path {
  fill: var(--text-invert);
} */

.index-chart-chart-type-popup {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  width: 225px;
  background-color: var(--surface-primary);
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  z-index: 100;
}

.index-chart-chart-type-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  color: var(--text-primary);
  user-select: none;
  transition: background 0.12s;
}

.index-chart-chart-type-option:hover {
  background-color: var(--color-brand-hover2);
}

.index-chart-chart-type-option-active {
  background-color: var(--color-brand-hover2);
}

.index-chart-chart-type-option-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* .index-chart-chart-type-option-icon svg {
  width: 20px;
  height: 20px;
} */
.index-chart-chart-type-option-icon svg path {
  fill: var(--text-primary);
}

.index-chart-body {
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

@media (hover: none) and (pointer: coarse) {
  .index-chart-body {
    overscroll-behavior: contain;
  }
}

.index-chart-body .chart-view {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/IndexChartWidget/IndexChartWidget.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,MAAM;AACR;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB;;eAEa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;GAGG;AACH;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":[".index-chart-widget-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  container-type: inline-size;\n}\n\n.index-chart-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 404px;\n}\n\n.index-chart-header-mobile {\n  width: 100%;\n}\n\n.index-chart-period-tab-bar {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  background-color: var(--row-dark);\n  padding: 2px 4px;\n  border-radius: 600px;\n  gap: 0;\n}\n\n.index-chart-period-tab {\n  flex: 1;\n  height: 32px;\n  padding: 4px 6px;\n  border: none;\n  background: none;\n  border-radius: 600px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  text-align: center;\n  white-space: nowrap;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.index-chart-period-tab:hover:not(.index-chart-period-tab-active) {\n  background-color: var(--color-brand-hover2);\n}\n\n.index-chart-period-tab-active {\n  background-color: var(--color-brand);\n  color: var(--text-invert);\n}\n\n.index-chart-chart-type-button-wrapper {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.index-chart-chart-type-button {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-brand);\n  border-radius: 4px;\n  background: none;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.index-chart-chart-type-button:hover {\n  background-color: var(--color-brand-hover2);\n}\n\n.index-chart-chart-type-button svg path {\n  fill: var(--color-brand);\n}\n\n.index-chart-chart-type-button-open {\n  background-color: var(--color-brand-hover2);\n}\n\n/* .index-chart-chart-type-button-open svg path {\n  fill: var(--text-invert);\n} */\n\n.index-chart-chart-type-popup {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  width: 225px;\n  background-color: var(--surface-primary);\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  padding: 8px 0;\n  z-index: 100;\n}\n\n.index-chart-chart-type-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  color: var(--text-primary);\n  user-select: none;\n  transition: background 0.12s;\n}\n\n.index-chart-chart-type-option:hover {\n  background-color: var(--color-brand-hover2);\n}\n\n.index-chart-chart-type-option-active {\n  background-color: var(--color-brand-hover2);\n}\n\n.index-chart-chart-type-option-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* .index-chart-chart-type-option-icon svg {\n  width: 20px;\n  height: 20px;\n} */\n.index-chart-chart-type-option-icon svg path {\n  fill: var(--text-primary);\n}\n\n.index-chart-body {\n  width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (hover: none) and (pointer: coarse) {\n  .index-chart-body {\n    overscroll-behavior: contain;\n  }\n}\n\n.index-chart-body .chart-view {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
